export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/pointRadial.js
// module id = Wbd7
// module chunks = 0